import { Injectable } from '@angular/core';
import { ApiConService } from '../shared/api-con.service';
import { UsuarioOcorrencia } from './model/usuarioOcorrencia.model';
import { MotoristaConfig } from './model/motoristaConfig.model';
import { Util } from '../shared/util.service';
import { MainContainerService } from '../main-container/main-container.service';
import { JsonReturn, ObjectParam } from '../interface/generic-interface';

@Injectable()
export class PopupConfigService {

  public json: any;
  objOcorrencia: any;
  filtroAvancadoAtivo = false;
  usuariosOcorrencia: Array<UsuarioOcorrencia> = []
  motoristas: Array<MotoristaConfig> = [];
  motoristasFiltro: Array<MotoristaConfig> = [];
  mostraMotorista = false;
  public vetListaStatusFinalizacao: any[] = [];
  public vetListaTipoRecusa: any[] = [];
  usuariosDescSelecionados = ''
  descMotoristas = ''
  qtdUsuarioSel = 0;
  qtdMotorSel = 0;
  chaveAcesso: string = null;
  mostraBtnCompartilhar: boolean = false;

  constructor(
    private mainContainerService : MainContainerService,
    private conService: ApiConService, 
        private util: Util,) { }

  async getListMotivos() {
    try {
      const response: JsonReturn = await this.conService.patch('DCmotivoOcorrencia');
      return response.response;
    }catch (Error) {
      console.log("CATCH________getListMotivos");
      console.log(Error);
    }
  }

  async postCadastraMotivo(objParam: ObjectParam) {
    try {
      const response = await this.conService.post('DCmotivoOcorrencia', objParam);
      return response;
    }catch (Error) {
      console.log("CATCH________postCadastraMotivo");
      console.log(Error);
    }
  }

  async postCadastraStatusFinalizacao(descricao, ativo) {
    try {
      const objParam: ObjectParam = {
        ocorrenciasStatusFinalizacao :{
        Descricao: descricao,
        Ativo: ativo
       }
      }
      const response = await this.conService.post('DCocorrenciasStatusFinalizacao', objParam);
      return response;
    } catch (Error) {
        console.log("CATCH________postCadastraStatusFinalizacao");
        console.log(Error);
    }
  }

  async putCadastraStatusFinalizacao(idStatusFinalizacao: number, descricao: string, situacao: string) {
    try {
      let objParam: ObjectParam = {
        ocorrenciasStatusFinalizacao : {
          Descricao: descricao,
          Ativo: situacao
        }  
      };
      const response = await this.conService.put('DCocorrenciasStatusFinalizacao', `${idStatusFinalizacao}`, objParam);
      return response;
    } catch (e) {
        console.log("CATCH________putCadastraStatusFinalizacao");
        console.log(e);
    }
  }

  async getListaStatusFinalizacao() 
  {
    try 
    {
      const response: JsonReturn = await this.conService.patch('DCocorrenciasStatusFinalizacao');      
      return response.response;
    } 
    catch (e) 
    {
      console.log(e);
    }
  }

  async getListaOcorrenciaLog(idOcorrencia: Number) 
  {
    try 
    {
      const response: JsonReturn = await this.conService.patch(`DCocorrenciasLog/${idOcorrencia}`);
      return response.response;
    } 
    catch (e) 
    {
      console.log(e);
    }
  }

  async getListaPedidoNotaOcorrencia(codigoOcorrencia: string, codigoCliente: number) 
  {
    this.mainContainerService.loadingListaPedidosNotas = true;
    try 
    {
      const response: JsonReturn = await this.conService.patch(`DCocorrencias/pedidosNotas/${codigoOcorrencia}/${codigoCliente}`);
      return response.response;
    } 
    catch (e) 
    {
      console.log(e);
    }finally{
       this.mainContainerService.loadingListaPedidosNotas = false
    }
  }

  async getListaTipoRecusa() 
  {
    try 
    {
      const response: JsonReturn = await this.conService.patch('DCTipoRecusa');
      return response.response;
    } 
    catch (e) 
    {
      console.log(e);
    }
  }

  async getListaTipoVoltoDepois() 
  {
    try 
    {
      const response: JsonReturn = await this.conService.patch('DCTipoVoltoDepois');
      return response.response;
    } 
    catch (e) 
    {
      console.log(e);
    }
  }

  async postCadastraTipoRecusa(descricao, ativa) {
    try {
      const objParam: ObjectParam = {
        tipoRecusa: {
          Descricao: descricao,
          Ativa: ativa
        }
      }
      const response = await this.conService.post('DCTipoRecusa', objParam);
      return response;
    } catch (error) {
      console.log('Erro ao cadastrar Tipo Recusa' + error)
    }
  }

  async postCadastraTipoVoltoDepois(descricao, ativa) {
    try {
      const objtParam: ObjectParam = {
        tipoVoltoDepois: {
          Descricao: descricao,
          Ativa: ativa
        }
      }
      const response = await this.conService.post('DCTipoVoltoDepois', objtParam);
      return response;
    } catch (error) {
      console.log('Erro ao cadastrar Tipo Volto Depois' + error)
    }
  }
  
  async atualizarTipoRecusa(idTipoRecusa, descricao, ativa) {
    try {
      let objParam: ObjectParam = {
        tipoRecusa: {
          Descricao: descricao,
          Ativa: ativa
        }
      }
      const response = await this.conService.put('DCTipoRecusa', idTipoRecusa,  objParam);
      return response;
    } catch (error) {
      console.log('Erro ao cadastrar Tipo Recusa' + error)
    }
  }


  async atualizaSituacaoOcEspecial(ocorrenciaEspecialID, obj: any) {    
    try {     
      const response = await this.conService.put('DCocorrenciaEspecial/situacao',  ocorrenciaEspecialID,  obj);
      return response;
    } catch (error) {
      console.log('Erro atualizar situação OC especial' + error)
    }
  }


  async atualizarTipoVoltoDepois(idTipoRecusa, descricao, ativa) {
    try {
      let objtParam: ObjectParam = {
        tipoVoltoDepois: {
          Descricao: descricao,
          Ativa: ativa
        }
      }
      const response = await this.conService.put('DCTipoVoltoDepois',  idTipoRecusa,  objtParam);
      return response;
    } catch (error) {
      console.log('Erro ao cadastrar Tipo Volto Depois' + error)
    }
  }

  async atualizarMotivoOc(idMotivoOcorrencia, descricao, ativa) {
    try {
      let objParam : ObjectParam = {
        motivoOcorrencia : {
          Descricao: descricao,
          Ativa: ativa
        }
      }  

      const response = await this.conService.put('DCmotivoOcorrencia',  idMotivoOcorrencia,  objParam);
      return response;
    } catch (error) {
      console.log('Erro ao atualiar motivo ocorrência' + error)
    }
  }

  async getMotoristas() {
    try {     
      const response: JsonReturn = await this.conService.patch('DCmotorTransp/motoristas');
      return response.response;
    } catch (error) {
      console.log('Erro ao consultar motoristas' + error)
    }
  }

  async getConfiguracoesGerais(){    
    try {
        const response: JsonReturn = await this.conService.patch('DCConfiguracaoGeral');
        let configuracoesGerais = response.response;        
        return configuracoesGerais;
    } catch (error) {
        console.log(error);
    }
  }


  async updateConfiguracaoGeral(id: number, objParam: ObjectParam) {
    try {
      const response = await this.conService.put('DCConfiguracaoGeral', `${id}`, objParam);
      return response;
    }catch (error) {
        console.log(error);
    }
  }

  async postCadastrUsuarioOcorrencia(objParam: ObjectParam) {
    try {
      const response = await this.conService.post('DCUsuariosOcorrencia', objParam);
      return response;
    }catch (Error) {
      console.log("Erro ao inserir usuario ocorrencia")
    }
  }

  async putCadastrUsuarioOcorrencia(id: number, objParam: ObjectParam) {
    try {
      const response: JsonReturn = await this.conService.put('DCUsuariosOcorrencia', `${id}` ,objParam);
      return response;
    }catch (Error) {
      console.log("Erro ao atualizar usuario ocorrencia")
    }
  }

  
  async getListaUsuarioOcorrencia(){    
    try {
        const response: JsonReturn = await this.conService.patch('DCUsuariosOcorrencia');              
        return response.response;
    } catch (error) {
        console.log(error);
    }
  }

  async deleteUsuarioOCMotor(usuarioOcMotor){
    try {
      const response = await this.conService.delete('DCUsuarioOcMotor/del', usuarioOcMotor);
    }catch (Error) {
      console.log("Erro ao exluir usuarioOcMotor")
    }
  }

  async inserirUsuarioOcMotor(usuarioOcMotor){
    try {
      const response = await this.conService.post('DCUsuarioOcMotor', usuarioOcMotor);
    }catch (Error) {
      console.log("Erro ao inserir usuarioOcMotor")
    }
  }

  async getUsuarioOcMotor(){
    try {
      const response: JsonReturn = await this.conService.patch('DCUsuarioOcMotor');
      return response.response
    }catch (Error) {
      console.log("Erro ao inserir usuarioOcMotor")
    }
  }  


  atualizaUsuariosChecked(){
    this.usuariosOcorrencia = this.usuariosOcorrencia.filter((usuario) => usuario.Ativo);
    let url = new URL(window.location.href);

    let nomeUsuario: any = url.searchParams.get('opc3');
    nomeUsuario = atob(nomeUsuario);

  
    
    this.usuariosOcorrencia.forEach((usuario => {
      if(usuario.Usuario.toLowerCase().includes(nomeUsuario.toLowerCase())){
        usuario.checked = true;
      }else{
        usuario.checked = false;
      }
      return usuario;
    }));
    this.atualizaMotoristasChecked();
    this.atualizaDescUsuariosSel();
  }


  atualizaMotoristasChecked(){
    this.motoristasFiltro.forEach((motor)=> motor.checked = false);
    
    let algumUsuarioChecked = this.usuariosOcorrencia.some((usuario) =>usuario.checked == true);
    if(algumUsuarioChecked){

      this.usuariosOcorrencia.forEach((usuario) => {
        
        if(usuario.checked){
         usuario.motoristas.forEach((motor ) => {
          let motorFind = this.motoristasFiltro.find((mot) => mot.MotorID == motor.MotorID)
          motorFind.checked = true;
         })
        }
      })
    }else {  
      this.motoristasFiltro.forEach((motor)=> motor.checked = true);
    }

 
    this.atualizaDescMotoristas()
    this.filtraRoteirosTela()
  
  }

  atualizaDescUsuariosSel(){
    let value = this.usuariosOcorrencia.filter((usuario: UsuarioOcorrencia) => usuario.checked == true);
    this.usuariosDescSelecionados =  value.map(item => item.Usuario).join(',\n');
    this.qtdUsuarioSel = value.length;
  }

  atualizaDescMotoristas(){
    let value = this.motoristasFiltro.filter((motor: MotoristaConfig) => motor.checked == true);
    this.descMotoristas =  value.map(item => item.Nome).join(',\n');
    this.qtdMotorSel =  value.length;
  }

  filtraRoteirosTela(){
   
    if(this.filtroAvancadoAtivo){  
      let motoristaDesmarcados = this.motoristasFiltro.filter((motor) => !motor.checked)
    
      motoristaDesmarcados.forEach((motor) => {
        
        this.mainContainerService.listaRoteiros.forEach((roteiro) => {
          
          if(roteiro.nome_motorista.toLowerCase().includes(motor.Nome.toLowerCase())){
            roteiro.mostraRoteiro = false
          }
        })
      })
      
    }
  
  }
  
}
